import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  SxProps,
  Theme,
  Checkbox,
} from "@mui/material";
import { Item } from "../../modules/users/components/UserItemsTable";
import CardBox from "./CardBox";

export default function SelectItemsTable(props: {
  items: Item[];
  selectedItems: Item[];
  setSelectedItems: (items: Item[]) => void;
  sx?: SxProps<Theme>;
}) {
  const { items, sx } = props;
  const toggleItem = (item: Item) => {
    const { selectedItems, setSelectedItems } = props;
    const newSelectedItems = [...selectedItems];
    const itemIndex = newSelectedItems.findIndex(
      (selectedItem) => selectedItem.id === item.id
    );
    if (itemIndex === -1) {
      newSelectedItems.push(item);
    } else {
      newSelectedItems.splice(itemIndex, 1);
    }
    setSelectedItems(newSelectedItems);
  };

  return (
    <CardBox sx={{ width: "100%" }}>
      <TableContainer
        sx={
          sx ?? {
            maxHeight: "300px",
            overflow: "auto",
          }
        }
      >
        <Table size="small" stickyHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell align="center">
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    Nenhum item encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {items.map((item) => {
              return (
                <TableRow key={item.id}>
                  <TableCell
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    align="left"
                  >
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Checkbox
                      sx={{
                        width: {
                          xs: "25px",
                        },
                        height: {
                          xs: "25px",
                        },
                        marginLeft: {
                          xs: "auto",
                          sm: "10px",
                        },
                      }}
                      onClick={() => toggleItem(item)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </CardBox>
  );
}
